export const EMPLOYEES_LIST_PATH = '/dashboard/admin/employees';
export const OUTSOURCE_EMPLOYEES_LIST_PATH = '/dashboard/admin/outsource-employee';

export const EMPTY_EMPLOYEE_LIST_FILTERS = {
  accountable_department_id: '',
  role_id: '',
  is_reporting_supervisor: '',
  location_id: '',
};

const FILTER_KEYS = Object.keys(EMPTY_EMPLOYEE_LIST_FILTERS);

export function readEmployeeListStateFromSearchParams(searchParams) {
  const filters = { ...EMPTY_EMPLOYEE_LIST_FILTERS };
  FILTER_KEYS.forEach((key) => {
    filters[key] = String(searchParams.get(key) || '');
  });
  return { filters };
}

export function hasEmployeeListParams(searchParams) {
  if (!searchParams) return false;
  return FILTER_KEYS.some((key) => String(searchParams.get(key) || '').trim() !== '');
}

export function employeeListStateToSearchParams({ filters } = {}) {
  const params = new URLSearchParams();
  FILTER_KEYS.forEach((key) => {
    const value = String(filters?.[key] || '').trim();
    if (value) params.set(key, value);
  });
  return params;
}

export function employeesListPath(state) {
  const qs = employeeListStateToSearchParams(state).toString();
  return qs ? `${EMPLOYEES_LIST_PATH}?${qs}` : EMPLOYEES_LIST_PATH;
}

export function getInitialEmployeeListState() {
  const params = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : ''
  );
  if (hasEmployeeListParams(params)) return readEmployeeListStateFromSearchParams(params);
  return { filters: { ...EMPTY_EMPLOYEE_LIST_FILTERS } };
}

export function employeeListBackPath(location, { isOutsource = false } = {}) {
  const from = location?.state?.from;
  if (typeof from === 'string') {
    const pathOnly = from.split('?')[0];
    if (pathOnly === EMPLOYEES_LIST_PATH) {
      const qs = from.includes('?') ? from.slice(from.indexOf('?') + 1) : '';
      const filters = readEmployeeListStateFromSearchParams(new URLSearchParams(qs)).filters;
      return employeesListPath({ filters });
    }
    if (pathOnly === OUTSOURCE_EMPLOYEES_LIST_PATH) {
      return OUTSOURCE_EMPLOYEES_LIST_PATH;
    }
  }
  if (isOutsource) return OUTSOURCE_EMPLOYEES_LIST_PATH;
  return EMPLOYEES_LIST_PATH;
}

export function employeeListBackLabel(location, { isOutsource = false } = {}) {
  const pathOnly = employeeListBackPath(location, { isOutsource }).split('?')[0];
  return pathOnly === OUTSOURCE_EMPLOYEES_LIST_PATH ? 'Helper Employees' : 'Employees';
}
